import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

interface ResultsPaginationTopProps {
  currentPage: number;
  totalResults: number; // Total de resultados no CHUNK atual
  resultsPerPage: number;
  onPageChange: (page: number) => void;
  hasMoreChunks: boolean;
}

const ResultsPaginationTop: React.FC<ResultsPaginationTopProps> = ({ 
  currentPage, 
  totalResults, 
  resultsPerPage, 
  onPageChange,
  hasMoreChunks
}) => {
  const { t } = useTranslation();
  // totalPages agora é o total de páginas DENTRO do chunk
  const totalDisplayPages = Math.ceil(totalResults / resultsPerPage);

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    // Se houver mais páginas de exibição no chunk atual, ou se for a última página do chunk mas houver mais chunks
    if (currentPage < totalDisplayPages || (currentPage === totalDisplayPages && hasMoreChunks)) {
      onPageChange(currentPage + 1);
    }
  };

  if (totalResults === 0) return null;

  // Desabilitado se estiver na última página de exibição E não houver mais chunks
  const isNextDisabled = currentPage === totalDisplayPages && !hasMoreChunks;

  return (
    <motion.div 
      className="flex items-center gap-2"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.8 }}
    >
      <motion.button
        onClick={handlePrevious}
        disabled={currentPage === 1}
        className="flex items-center justify-center rounded-lg h-8 w-8 bg-gray-100 dark:bg-gray-900/50 hover:bg-gray-200 dark:hover:bg-gray-700/50 text-gray-600 dark:text-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        whileHover={{ scale: currentPage === 1 ? 1 : 1.05 }}
        whileTap={{ scale: currentPage === 1 ? 1 : 0.95 }}
      >
        <span className="material-symbols-outlined text-lg">chevron_left</span>
      </motion.button>
      
      <p className="text-sm font-medium text-[#181411] dark:text-white">
          {t('dashboard.pagination_page', { current: currentPage, total: totalDisplayPages })}
      </p>
      
      <motion.button
        onClick={handleNext}
        disabled={isNextDisabled}
        className="flex items-center justify-center rounded-lg h-8 w-8 bg-gray-100 dark:bg-gray-900/50 hover:bg-gray-200 dark:hover:bg-gray-700/50 text-gray-600 dark:text-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        whileHover={{ scale: isNextDisabled ? 1 : 1.05 }}
        whileTap={{ scale: isNextDisabled ? 1 : 0.95 }}
      >
        <span className="material-symbols-outlined text-lg">chevron_right</span>
      </motion.button>
    </motion.div>
  );
};

export default ResultsPaginationTop;